
import { BookYearService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			bookyears: BookYearService.bookYears,
			selectedYears: [BookYearService.selectedBookYear] as number[]
		};
	},
	props: {
		title: {
			type: String,
		}
	},
	computed: {
		computedTitle():string{
			if (this.title){
				return this.title;
			}
			return this.$ct("select-bookyears").toString();
		},
		allItemsSelected():boolean {
			return this.bookyears.length == this.selectedYears.length;
		},
		confirmDisabled():boolean{
			return this.selectedYears.length == 0;
		}
	},
	methods: {
		isBookYearSelected(year:number):boolean {
			return this.selectedYears.indexOf(year) != -1;
		},
		toggleBookYear(year:number){
			let i = this.selectedYears.indexOf(year);
			if (i == -1) {
				this.selectedYears.push(year);
			}else{
				this.selectedYears.splice(i,1);
			}
		},
		toggleAllItemsSelected(){
			if (this.allItemsSelected){
				this.selectedYears.splice(0, this.selectedYears.length);
			}else{
				this.selectedYears.splice(0, this.selectedYears.length);
				this.selectedYears.push(...this.bookyears.map(b=>b.Year));
			}
		},
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("confirm", this.selectedYears.sort());
			this.close();
		}
	},
	i18nEx: {
		componentPrefix: "components.bookyear"
	}
});
